import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { Icon } from '../Icons';
import { useSelector } from 'react-redux';
import { updateRoomLock } from '../../actions/RoomActions';
import { withRoomContext } from '../../lib/RoomClientContext';
import { createSelector } from '@reduxjs/toolkit';

// Base selectors
const selectIsRoomLocked = (state) => state.room.isRoomLocked;
const selectToken = (state) => state.user.token;
const selectRoomId = (state) => state.user.roomId;

// Composed selector for RoomLockToggle
const selectRoomLockToggleState = createSelector(
  [selectIsRoomLocked, selectToken, selectRoomId],
  (isLocked, token, roomId) => ({
    isLocked,
    token,
    roomId,
  })
);

function RoomLockToggle({ roomClient }) {
  const { t } = useTranslation();

  // Use the memoized selector from Redux Toolkit
  const { isLocked, token, roomId } = useSelector(selectRoomLockToggleState);

  // Implement toggle functionality directly
  const handleToggleLock = (e) => {
    if (e) e.stopPropagation();
    updateRoomLock(token, roomId, !isLocked, t, roomClient);
  };

  return (
    <Tooltip title={t(isLocked ? 'Room is locked' : 'Room is unlocked')}>
      <IconButton onClick={handleToggleLock}>
        <Icon name={isLocked ? 'lock' : 'lockOpen'} color="white" />
      </IconButton>
    </Tooltip>
  );
}

// Wrap with room context and add a display name for easier debugging
const WrappedRoomLockToggle = withRoomContext(React.memo(RoomLockToggle));
WrappedRoomLockToggle.displayName = 'RoomLockToggle';

export default WrappedRoomLockToggle;
